export const mailings = [
  {
    path: '/mailings',
    component: () => import(/* webpackChunkName: "mailings" */ '@/views/mailings/Mailings'),
  },
]
